export function doLogout() {
    localStorage.removeItem('hoaoa-jwt');
    localStorage.removeItem('hoaoa-user');
    // this.props.history.push('/login');
    window.location.replace(`/login`);
};
